import React from "react";

export const CampaignStrategySkeleton: React.FC = () => {
  return (
    <div className="w-full flex flex-col gap-2">
      {/* ========================================================================= */}
      {/* BANDA 1: Controle Estratégico & Indicador de Prontidão (Grid 8/4)          */}
      {/* ========================================================================= */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-2 items-stretch">
        {/* Card 1: Objetivo Estratégico */}
        <div className="lg:col-span-7 xl:col-span-8 bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[140px]">
          <div>
            <div className="flex items-center gap-2.5 border-b border-purple-100 pb-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-purple-100 animate-pulse shrink-0" />
              <div className="flex-1 space-y-1">
                <div className="h-3.5 w-44 bg-gray-200 rounded-sm animate-pulse" />
                <div className="h-2.5 w-64 bg-gray-100 rounded-sm animate-pulse" />
              </div>
            </div>
            <div className="h-14 w-full bg-purple-50/40 rounded-lg border border-purple-100/60 animate-pulse" />
          </div>
          <div className="flex items-center justify-between pt-2 mt-2 border-t border-purple-50">
            <div className="h-3 w-48 bg-gray-100 rounded-sm animate-pulse" />
            <div className="h-7 w-28 bg-purple-100 rounded-lg animate-pulse" />
          </div>
        </div>

        {/* Card 2: Prontidão & Gamificação da Campanha */}
        <div className="lg:col-span-5 xl:col-span-4 bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[140px]">
          <div>
            <div className="flex items-center justify-between border-b border-purple-100 pb-2 mb-3">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-indigo-100 animate-pulse shrink-0" />
                <div>
                  <div className="h-3 w-28 bg-gray-200 rounded-sm animate-pulse mb-1" />
                  <div className="h-2.5 w-36 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              </div>
              <div className="h-7 w-12 bg-purple-100 rounded-md animate-pulse" />
            </div>

            {/* Barra de Progresso */}
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="h-2.5 w-24 bg-gray-200 rounded-sm animate-pulse" />
                <div className="h-2.5 w-16 bg-gray-200 rounded-sm animate-pulse" />
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2 overflow-hidden">
                <div className="h-full bg-purple-200 w-1/2 rounded-full animate-pulse" />
              </div>
            </div>
          </div>

          <div className="flex items-center gap-1.5 pt-2 mt-2 border-t border-purple-50">
            <div className="h-7 flex-1 bg-gray-100 rounded-lg animate-pulse" />
            <div className="h-7 flex-1 bg-gray-100 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>

      {/* ========================================================================= */}
      {/* BANDA 2: Comitê de Agentes de IA (Grid 2x2 Rigoroso)                       */}
      {/* ========================================================================= */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-stretch">
        {/* Agente 1: Sarah (CMO) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[380px]">
          <div>
            {/* Header do Agente */}
            <div className="flex items-center justify-between border-b border-purple-100 pb-2 mb-3">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-xl bg-purple-100 animate-pulse shrink-0" />
                <div>
                  <div className="h-3.5 w-28 bg-gray-200 rounded-sm animate-pulse mb-1" />
                  <div className="h-2.5 w-36 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              </div>
              <div className="h-5 w-20 bg-purple-50 border border-purple-100 rounded-full animate-pulse" />
            </div>

            {/* Conteúdo do Agente */}
            <div className="p-3 bg-purple-50/30 rounded-xl border border-purple-100/60 space-y-2 mb-3">
              <div className="h-3 w-full bg-gray-200/70 rounded-sm animate-pulse" />
              <div className="h-3 w-5/6 bg-gray-200/70 rounded-sm animate-pulse" />
              <div className="h-3 w-4/6 bg-gray-200/70 rounded-sm animate-pulse" />
              <div className="h-3 w-full bg-gray-200/70 rounded-sm animate-pulse" />
            </div>
          </div>

          {/* Command Input Skeleton */}
          <div className="h-9 w-full bg-gray-50 border border-purple-100 rounded-lg animate-pulse" />
        </div>

        {/* Agente 2: Max (Tráfego) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[380px]">
          <div>
            {/* Header do Agente */}
            <div className="flex items-center justify-between border-b border-purple-100 pb-2 mb-3">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-xl bg-blue-100 animate-pulse shrink-0" />
                <div>
                  <div className="h-3.5 w-28 bg-gray-200 rounded-sm animate-pulse mb-1" />
                  <div className="h-2.5 w-36 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              </div>
              <div className="h-5 w-20 bg-blue-50 border border-blue-100 rounded-full animate-pulse" />
            </div>

            {/* Campaign Cards Skeleton */}
            <div className="space-y-2 mb-3">
              {[...Array(2)].map((_, i) => (
                <div
                  key={i}
                  className="p-2.5 rounded-xl border border-blue-100/80 bg-blue-50/20 flex flex-col gap-2"
                >
                  <div className="flex justify-between items-center">
                    <div className="h-3 w-28 bg-blue-200 rounded-sm animate-pulse" />
                    <div className="h-4 w-16 bg-blue-100 rounded-md animate-pulse" />
                  </div>
                  <div className="h-3 w-full bg-gray-200 rounded-sm animate-pulse" />
                  <div className="h-2.5 w-3/4 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              ))}
            </div>
          </div>

          {/* Command Input Skeleton */}
          <div className="h-9 w-full bg-gray-50 border border-purple-100 rounded-lg animate-pulse" />
        </div>

        {/* Agente 3: Alex (Analytics) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[380px]">
          <div>
            {/* Header do Agente */}
            <div className="flex items-center justify-between border-b border-purple-100 pb-2 mb-3">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-xl bg-emerald-100 animate-pulse shrink-0" />
                <div>
                  <div className="h-3.5 w-28 bg-gray-200 rounded-sm animate-pulse mb-1" />
                  <div className="h-2.5 w-36 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              </div>
              <div className="h-5 w-20 bg-emerald-50 border border-emerald-100 rounded-full animate-pulse" />
            </div>

            {/* Verba & Missões */}
            <div className="space-y-2.5 mb-3">
              <div className="p-2.5 rounded-xl bg-emerald-50/30 border border-emerald-100/70 space-y-2">
                <div className="flex justify-between items-center">
                  <div className="h-3 w-28 bg-emerald-200 rounded-sm animate-pulse" />
                  <div className="h-3.5 w-20 bg-emerald-200 rounded-sm animate-pulse" />
                </div>
                <div className="h-2 bg-emerald-100 rounded-full animate-pulse" />
              </div>
              <div className="space-y-1.5">
                {[...Array(2)].map((_, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-2 p-2 rounded-lg border border-gray-100 bg-gray-50/50"
                  >
                    <div className="w-4 h-4 rounded-full bg-gray-200 animate-pulse shrink-0" />
                    <div className="h-3 w-4/5 bg-gray-200 rounded-sm animate-pulse" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Command Input Skeleton */}
          <div className="h-9 w-full bg-gray-50 border border-purple-100 rounded-lg animate-pulse" />
        </div>

        {/* Agente 4: Mia (Social Media) */}
        <div className="bg-white rounded-xl border border-purple-200 p-3.5 shadow-xs flex flex-col justify-between min-h-[380px]">
          <div>
            {/* Header do Agente */}
            <div className="flex items-center justify-between border-b border-purple-100 pb-2 mb-3">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-xl bg-pink-100 animate-pulse shrink-0" />
                <div>
                  <div className="h-3.5 w-28 bg-gray-200 rounded-sm animate-pulse mb-1" />
                  <div className="h-2.5 w-36 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              </div>
              <div className="h-5 w-20 bg-pink-50 border border-pink-100 rounded-full animate-pulse" />
            </div>

            {/* Organic Suggestions */}
            <div className="space-y-2 mb-3">
              {[...Array(2)].map((_, i) => (
                <div
                  key={i}
                  className="p-2.5 rounded-xl border border-pink-100/80 bg-pink-50/20 flex flex-col gap-1.5"
                >
                  <div className="flex justify-between items-center">
                    <div className="h-4 w-16 bg-pink-100 rounded-md animate-pulse" />
                    <div className="h-6 w-20 bg-pink-100 rounded-lg animate-pulse" />
                  </div>
                  <div className="h-3 w-full bg-gray-200 rounded-sm animate-pulse" />
                  <div className="h-2.5 w-2/3 bg-gray-100 rounded-sm animate-pulse" />
                </div>
              ))}
            </div>
          </div>

          {/* Command Input Skeleton */}
          <div className="h-9 w-full bg-gray-50 border border-purple-100 rounded-lg animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default CampaignStrategySkeleton;
